import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, ArrowLeft, CheckCircle } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const T = { vert: '#1e4a1a', or: '#c4a76c', bg: '#faf9f6', border: '#e8e5e0', textPrimary: '#1a1a1a', textSecondary: '#6b7280', textMuted: '#9ca3af', inputBg: '#f5f3ef' };

const AdminForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) throw new Error('Erreur serveur');
      setSent(true);
    } catch (err) { console.error('Forgot password error:', err);
      setError('Une erreur est survenue. Veuillez reessayer.');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = { background: T.inputBg, border: `1px solid ${T.border}`, color: T.textPrimary, fontFamily: "'Montserrat', sans-serif" };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: T.bg }} data-testid="forgot-password-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-12">
          <img
            src="/assets/logos/logo-dore.png"
            alt="One Green Dev"
            className="h-16 w-auto object-contain mx-auto mb-4"
          />
          <p className="text-[10px] tracking-[0.3em] uppercase" style={{ fontFamily: "'Montserrat', sans-serif", color: T.or }}>Administration</p>
        </div>

        <div className="rounded-2xl p-8 bg-white" style={{ border: `1px solid ${T.border}`, boxShadow: '0 4px 24px rgba(0,0,0,0.04)' }}>
          {sent ? (
            <div className="text-center" data-testid="forgot-password-success">
              <CheckCircle className="w-10 h-10 mx-auto mb-4" style={{ color: T.vert }} />
              <h2 className="text-lg mb-2" style={{ fontFamily: "'Playfair Display', serif", color: T.textPrimary }}>Email envoye</h2>
              <p className="text-[13px] mb-6" style={{ fontFamily: "'Montserrat', sans-serif", color: T.textSecondary }}>
                Si un compte existe avec cet email, vous recevrez un lien de reinitialisation.
              </p>
              <button onClick={() => navigate('/ogd-access-gate')} data-testid="back-to-login-btn"
                className="w-full py-3 rounded-xl text-[13px] font-semibold text-white transition-all"
                style={{ background: T.vert, fontFamily: "'Montserrat', sans-serif" }}>
                Retour a la connexion
              </button>
            </div>
          ) : (
            <>
              <h2 className="text-lg mb-1" style={{ fontFamily: "'Playfair Display', serif", color: T.textPrimary }}>Mot de passe oublie</h2>
              <p className="text-[13px] mb-8" style={{ fontFamily: "'Montserrat', sans-serif", color: T.textSecondary }}>
                Entrez votre email pour recevoir un lien de reinitialisation.
              </p>

              {error && (
                <div className="mb-6 p-3 rounded-xl text-sm" style={{ background: 'rgba(239,68,68,0.06)', border: '1px solid rgba(239,68,68,0.12)', color: '#dc2626', fontFamily: "'Montserrat', sans-serif" }}>
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label className="block text-[11px] font-medium uppercase tracking-wider mb-2" style={{ fontFamily: "'Montserrat', sans-serif", color: T.textMuted }}>Email</label>
                  <input type="email" value={email} onChange={e => { setEmail(e.target.value); setError(''); }} required
                    data-testid="forgot-email-input" placeholder="admin@onegreendev.com"
                    className="w-full px-4 py-3 rounded-xl text-sm outline-none transition-colors focus:ring-2 focus:ring-emerald-200" style={inputStyle} />
                </div>
                <button type="submit" disabled={loading} data-testid="forgot-submit-btn"
                  className="w-full py-3.5 rounded-xl text-[13px] font-semibold transition-all text-white"
                  style={{ background: loading ? 'rgba(30,74,26,0.5)' : T.vert, fontFamily: "'Montserrat', sans-serif" }}>
                  {loading ? <Loader2 className="w-5 h-5 animate-spin mx-auto" /> : 'Envoyer le lien'}
                </button>
              </form>
            </>
          )}

          {!sent && (
            <button onClick={() => navigate('/ogd-access-gate')} data-testid="back-to-login-link"
              className="flex items-center gap-1.5 text-[12px] mt-5 mx-auto hover:underline"
              style={{ fontFamily: "'Montserrat', sans-serif", color: T.textMuted }}>
              <ArrowLeft className="w-3.5 h-3.5" /> Retour a la connexion
            </button>
          )}
        </div>

        <p className="text-center text-[11px] mt-8" style={{ fontFamily: "'Montserrat', sans-serif", color: T.textMuted }}>
          One Green Dev &mdash; Espace prive
        </p>
      </div>
    </div>
  );
};

export default AdminForgotPasswordPage;
